import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

interface Partner {
  name: string;
  logo: string;
}

const LOGOS = '/assets/images/home/partners';

@Component({
  imports: [TranslocoDirective],
  selector: 'app-home-partners',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './partners.html',
  styleUrl: './partners.css',
})
export class Partners {
  protected readonly partners: Partner[] = [
    { name: 'Aquaria KLCC', logo: `${LOGOS}/aquaria-klcc.webp` },
    { name: 'Zoo Negara', logo: `${LOGOS}/zoo-negara.webp` },
    { name: 'Farm In The City', logo: `${LOGOS}/farm-in-the-city.webp` },
    { name: 'Entopia', logo: `${LOGOS}/entopia-pantone.webp` },
    { name: 'Genting Nature Adventures', logo: `${LOGOS}/genting-nature-adventures.webp` },
    { name: 'Eufloria', logo: `${LOGOS}/eufloria.webp` },
    { name: 'Chocolate Museum', logo: `${LOGOS}/chocolate-museum.webp` },
    { name: 'Bugs Paradise Farm', logo: `${LOGOS}/bugs-paradise-farm.webp` },
    { name: 'Teochew Puppet & Opera House', logo: `${LOGOS}/teochew-puppet-opera-house.webp` },
    { name: 'Science Bridge Academy', logo: `${LOGOS}/science-bridge-academy.webp` },
    { name: 'Kevin Build', logo: `${LOGOS}/kevin-build.webp` },
  ];

  // Rendered twice back-to-back so the CSS marquee loops seamlessly.
  protected readonly marquee = [...this.partners, ...this.partners];
}
